import { Request } from '@/helpers'
import { ENDPOINTS } from '@/data'

const Delete = async (
    componentId: string,
    Components: Array<ComponentInterface>,
    InitNotification: Function,
    SetState: Function
) => {
    SetState({ Deleting: componentId })

    try {
        const { success, message } = await Request({
            path: ENDPOINTS.DELETE_COMPONENT,
            method: 'DELETE',
            body: { componentId }
        })

        if (success) {
            InitNotification(message)

            const components = structuredClone(Components)
            const index = components.findIndex(({ _id }) => _id === componentId)

            components.splice(index, 1)

            SetState({
                Components: components,
                Loading: false
            })
        }

        else InitNotification(message)
    }

    catch (error) {
        console.error(error)
        InitNotification('Something went wrong while trying to delete your component!')
    }

    finally {
        SetState({ Deleting: null })
    }
}

export default Delete
